import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import StatisticsBlock from "./sections/StatisticsBlock";
import TickerTapeBanner from "./sections/TickerTapeBanner";
import MarqueePortraitsRow1 from "./sections/MarqueePortraitsRow1";
import AboutTheAssembliesOfGod from "./sections/AboutTheAssembliesOfGod";
import MarqueePortraitsRow2 from "./sections/MarqueePortraitsRow2";
import AgNewsSection from "./sections/AgNewsSection";
import FeaturedNews from "./sections/FeaturedNews";
import FindAChurchNearYou from "./sections/FindAChurchNearYou";
import DiscoverAgMinistries from "./sections/DiscoverAgMinistries";
import AgPodcasts from "./sections/AgPodcasts";
import PodcastMarquee from "./sections/PodcastMarquee";
import ExploreResources from "./sections/ExploreResources";
import DevotionalBlock from "./sections/DevotionalBlock";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <StatisticsBlock />
      <TickerTapeBanner />
      <MarqueePortraitsRow1 />
      <AboutTheAssembliesOfGod />
      <MarqueePortraitsRow2 />
      <AgNewsSection />
      <FeaturedNews />
      <FindAChurchNearYou />
      <DiscoverAgMinistries />
      <AgPodcasts />
      <PodcastMarquee />
      <ExploreResources />
      <DevotionalBlock />
      <Footer />
    </div>;
}